import { Coord } from "../../../../../../../src/types/Interface";
import generatePoints from "../../../../../../../src/utils/generator/generatePoints";


export function generateChordPoints(cCoord: Coord, circleRadius: number, pointRadian: number, intersecRadius: number) {
    if (!cCoord || !circleRadius || !pointRadian || !intersecRadius) {
        return Array(3).fill({ x: 0, y: 0 });
    }
    const intersecCoord = generatePoints(cCoord, [pointRadian], intersecRadius)[0];
    const sideLength = Math.sqrt(Math.pow(circleRadius, 2) - Math.pow(intersecRadius, 2));

    const getCoord = (radian: number) => ({
        x: intersecCoord.x + Math.cos(radian) * sideLength,
        y: intersecCoord.y + Math.sin(radian) * sideLength
    });

    return [getCoord(pointRadian + Math.PI / 2), intersecCoord, getCoord(pointRadian - Math.PI / 2)];
}
